namespace $.$$ {

	$mol_style_define( $shm_remove_menu, {
		Menu: {
			minWidth: '10rem',
			flex: { direction: 'column' },
		},

		Remove_button: {
			width: '100%',
			justifyContent: 'flex-start',
		},

		Confirm: {
			padding: $mol_gap.text,
			gap: $mol_gap.text,
			flex: { direction: 'column' },
		},

		Confirm_actions: {
			justifyContent: 'flex-end',
		},
	} )

}
